import React, { useState, useEffect } from 'react';
import useStyles from './styles';

// Components
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import Loading from '../../components/Loading';
import Modal from '../../components/Modal';

// Util
import Public from '../../util/public';
import { useParams, useHistory } from 'react-router';
import api from '../../services/api';

function ResetPassword({}) {
  const classes = useStyles();
  const [loading, setLoading] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const history = useHistory();
  const {forgotPasswordToken} = useParams();

  const [modalMessage, setModalMessage] = useState(null);
  const [alertModal, setAlertModal] = useState(null);

  const resetPass = (p1, p2) => {
    if (p1 !== p2) {
      return setAlertModal("Passwords does not match");
    }

    setLoading(true);
    api().post(`/user/password/reset/${forgotPasswordToken}`, {password: p1})
    .then(response => {
      setLoading(false);
      if (response?.data?.msg) {
        setAlertModal(response.data.msg);
      }
      history.push('/');
    })
    .catch(err => {
      if (err?.response?.data?.msg) {
        setModalMessage(err.response.data.msg);
      }
      setLoading(false);
    })
  }

  const closeMessageModal = () => {
    setModalMessage(null);
    history.push('/');
  }
  
  return (
    <>
        <div className={classes.bg}>
            <>
            <form  id={"reset-form"} className={classes.form} onSubmit={(e) => {e.preventDefault(); resetPass(password, password2)}}>
              <h1>Reset Password</h1>
              <TextInput  id={"reset-password"} name={"reset-password"} value={password}   type={'password'} label="Password" onInput={setPassword}></TextInput>
              <TextInput  id={"reset-password2"} name={"reset-password2"} value={password2} type={'password'} label="Confirm Password" onInput={setPassword2} ></TextInput>

              <Button type="submit" disabled={loading}>{loading ? <Loading color={"white"} size={20}/> : "RESET PASSWORD"}</Button>
  
            </form>

            </>
            

            <img className={classes.logo} src={Public("icons/white-icon.png")} alt="Easy Scrum Logo"></img>
          </div>
      
      <Modal onCancel={closeMessageModal} visible={modalMessage !== null} title={"Alert"} cancelText={false} submitText={"Ok"} onSubmit={closeMessageModal}>
        {modalMessage}
      </Modal>
      <Modal visible={alertModal !== null} title={"Alert"} onCancel={() => setAlertModal(null)} onSubmit={() => setAlertModal(null)} cancelText={false} >
        {alertModal}
      </Modal>
    </>
  );
}

export default ResetPassword;